import {
    escapePrintViewText,
    normalizeInlineHtml,
    replaceMediaLikeTagsWithIds,
} from '@/common/questionPrintView/shared'

const buildGroupingQuestionPrintView = (content) => {
    const questionHtml = replaceMediaLikeTagsWithIds(content.question || '')
    const questionSectionHtml = questionHtml ? `<p>Question:</p>${questionHtml}` : ''
    const groupedRegionsHtml = (content.regions || [])
        .map((region) => {
            const regionTitle = escapePrintViewText(region.title || '')
            const regionItemsHtml = (content.items || [])
                .filter((item) => item.region === region.title)
                .map((item) => {
                    const itemValue = normalizeInlineHtml(replaceMediaLikeTagsWithIds(item.value || ''))

                    if (!itemValue) {
                        return ''
                    }

                    return `<p>${itemValue}</p>`
                })
                .filter(Boolean)
                .join('')

            if (!regionTitle || !regionItemsHtml) {
                return ''
            }

            return `<p>&nbsp;</p><p>${regionTitle}:</p>${regionItemsHtml}`
        })
        .filter(Boolean)
        .join('')

    return `${questionSectionHtml}${groupedRegionsHtml}`
}

export {buildGroupingQuestionPrintView}
